import { Controller } from "@hotwired/stimulus";

/**
 * Signup Modal Controller
 *
 * Manages the signup modal for unauthenticated users
 * when they attempt to access premium features
 */
export default class extends Controller {
  connect() {
    // Optional initialization
  }

  /**
   * Opens the signup modal
   * @param {Event} event - The triggering event
   */
  open(event) {
    event.preventDefault();

    // Find the modal element and show it
    const modal = document.getElementById("signup-modal");
    if (modal) {
      modal.showModal();
    }
  }
}
